<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-12">
               <h1 class="pull-left">
                  <span style="color:#00a65a">{{com_TVOwnerName()}}</span> Free PIN Reports
               </h1>
               <div class="pull-right">
                  <a href="#" @click="downloadNow" class="btn" style="background-color: #526883; color: white;"><i class="fa fa-download"></i> Download Filtered</a>
                  &nbsp;
                  <a href="#" class="btn" style="background-color: #526883; color: white; display: none;"><i class="fa fa-cloud-download" style="font-size: 16px;"></i> Download All</a>
               </div>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="searchReportData">
         <div class="row">
            <div class="col-xs-6 col-sm-2">
               <div class="form-group">
                  <filterDropdownOptions />
               </div>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="From" type="text" value="" name="starttime" id="starttime" v-model="starttime" autocomplete="off" class="form-control input-sm datePicker">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="To" type="text" value="" name="stoptime" id="stoptime" v-model="stoptime" class="form-control input-sm datePicker" autocomplete="off">
            </div>

            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="login_type" id="login_type" v-model="login_type" v-select="login_type" class="form-control input-sm select2" @change="searchReportData">
                  <option value="">Select Login Type (All)</option>
                  <option value="1">Yes</option>
                  <option value="2">No</option>
               </select>
            </div>
            
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="Search By PIN" type="text" name="login" id="login" v-model="login" class="form-control input-sm" value="">
            </div>

            <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group  btnLeft" style="margin-bottom: 5px">
               <button type="submit" class="btn btn-sm btn-submit pull-right">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total {{listArr.length}} Row Found
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th class="tdCenter">TV PIN</th>
                                 <th class="tdCenter">Login Date</th>
                                 <th class="tdCenter">Is Logged In</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(data, index) in listArr" :key="data.id">
                                 <td :class="'tdCenter tdSN'">
                                    {{parseInt(++index)}}
                                 </td>
                                 <td class="tdCenter success">
                                    {{com_removeTVPinPrefix(data.username, userData.reseller4.tv_pin_prefix)}}
                                 </td>
                                 <td class="tdCenter  ">
                                    {{data.created_at}}
                                 </td>
                                 <td class="tdCenter  ">
                                    <span v-if="data.after_activate_first_login_at">
                                       Yes
                                    </span>
                                    <span v-else>No</span>
                                 </td>
                             </tr>
                              <tr v-if="listArr.length==0">
                                 <td colspan="10" class="tdCenter" style="padding: 30px 0;"><b>No Records  Found</b></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <div class="table-responsive">
                     <table class="table table-middle-small table-bordered">
                        <tbody>
                           <tr>
                              <td class="success" style="width:50%">Total Records : </td>
                              <td class="info" style="text-align: left;">
                                 &nbsp; {{listArr.length}}
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>

               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
   import axios from 'axios'
   export default {
      name: "FlexFreePinReport",
      components: {
         filterDropdownOptions,
      },
      data() {
         return {
            listArr : [],
            userData : {},
            reseller_list : {},
            starttime : '',
            stoptime : '',
            login : '',
            userlevel:'',
            login_type:'',
            flexApiUrl : process.env.VUE_APP_APIFLEXURL,
         }
      },
      created(){
         if(!this.com_isTVReseller(true, [393])){
            this.$router.push('dashboard');
         }
         //Get User Level from user store
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         this.userlevel = userData.user_level;
         // End

         var rootObject = this;
         loader.show();
         axios.get('get-reseller-dropdown-data').then(function (response) {
            rootObject.reseller_list = response.data.data;
         })
         .catch(function (error) {
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage); 
            rootObject.com_errorHandel(error);
         });

         this.filterWiseDateRangeSet();
         this.searchReportData();
      },
      methods: {

         downloadNow(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('login_type', this.login_type)
            form.append('allow_child', 1)
            form.append('download', 1)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
   
            var config = {
               headers: { 'Content-Type': 'multipart/form-data' },
               responseType: 'blob',
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/free-pin-subscription', form, config).then(function (response) {
               //console.log(response);
               const blob = new Blob([response.data], { type: 'application/csv' });
               var a = document.createElement('a');
               var url = window.URL.createObjectURL(blob);
               a.href = url;
               var prefix = 'free_pin_report_'
               var file_name = prefix.concat(rootObject.getFormattedTime());
               var ext = '.csv';
               a.download = file_name.concat(ext);
               document.body.append(a);
               a.click();
               a.remove();
               window.URL.revokeObjectURL(url);
               loader.hide();
               
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },


         searchReportData(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('login_type', this.login_type)
            form.append('allow_child', 1)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
            
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
   
            axios.post(rootObject.flexApiUrl+'/reports/free-pin-subscription', form, config).then(function (response) {
               //console.log(response);
               rootObject.populateReportData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },
   
         populateReportData(response){
            var rootObject = this;
            var creationdate = '';
            this.listArr = response.data.data.pinData;
            loader.hide();
         },
   
         filterWiseDateRangeSet()
         {
            $(".datePicker").removeAttr('readonly', 'readonly'); 
            if ($("#short_filter").val()) {
               this.starttime = '';
               this.stoptime = '';
               $(".datePicker").attr('readonly', 'readonly'); 
            }else{
               var dateRangeArr = this.com_currentDateRange();
               this.starttime = dateRangeArr.startDate;
               this.stoptime = dateRangeArr.endDate;
            }
         },

         getFormattedTime() {
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth() + 1;
            var d = today.getDate();
            return y + "-" + m + "-" + d;
         },
         
      },
      mounted: function() {
         var rootObject = this;
         $('#starttime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.starttime = $(this).val();
         });

         $('#stoptime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.stoptime = $(this).val();
         });

         $("#short_filter").on('change', function(){
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
         });
   
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>